import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout.js";
import Home from "./routes/Home.js";
import StartupDetail from "./routes/StartupDetail.js";
import Submit from "./routes/Submit.js";
import Search from "./routes/Search.js";
import VcHome from "./routes/VcHome.js";
import VcDetail from "./routes/VcDetail.js";

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/startup/:slug" element={<StartupDetail />} />
        <Route path="/submit" element={<Submit />} />
        <Route path="/search" element={<Search />} />
        <Route path="/vcs" element={<VcHome />} />
        <Route path="/vc/:slug" element={<VcDetail />} />
      </Routes>
    </Layout>
  );
}
